import activities from './activities'
import aiInventory from './aiInventory'
import alert from './alert'
import assetInventory from './assetInventory'
import auditProcess from './auditProcess'
import audits from './audits'
import cardFlag from './cardFlags'
import certificates from './certificates'
import changesManagement from './changesManagement'
import committees from './committees'
import community from './community'
import company from './company'
import externalServices from './services/externalServices'
import companyGuestPortalConfig from './companyGuestPortalConfig'
import companySuppliers from './companySuppliers'
import companyTrail from './companyTrail'
import complaint from './complaint'
import consent from './consent'
import consentFormReports from './consentFormReports'
import contactQuestionnaire from './contactQuestionnaire'
import cookies from './cookies'
import countries from './countries'
import course from './course'
import courseAccess from './courseAccess'
import dai from './dai'
import dataCollected from './dataCollected'
import dataIntelligence from './dataIntelligence'
import dataProcess from './dataProcess'
import dataProcessTreatment from './dataProcessTreatment'
import dataTreatmentAgents from './dataTreatmentAgents'
import date from './date'
import departments from './departments'
import diffViewer from './diffViewer'
import discountCoupon from './discountCoupon'
import documents from './documents'
import documentsValidations from './documentsValidations'
import dpoday from './dpoday'
import errors from './errors'
import evaluationSettings from './evaluationSettings'
import externalPlatformIntegrations from './externalPlatformIntegrations'
import faqs from './faqs'
import faqsDocumentations from './faqsDocumentations'
import fragilities from './fragilities'
import fragilityEntities from './fragilityEntities'
import googleTagManager from './googleTagManager'
import guestJourney from './guestJourney'
import governanceProject from './governanceProject'
import governanceProjectActivity from './governanceProjectActivity'
import governanceProjectSettings from './governanceProjectSettings'
import governanceProjectStages from './governanceProjectStages'
import incidentAcceptTexts from './incidentAcceptTexts'
import incidentHighRisk from './incidentHighRisk'
import incidentManegement from './incidentManegement'
import incidentRiskAssumption from './incidentRiskAssumption'
import incidents from './incidents'
import inviteAdvisor from './inviteAdvisor'
import jodit from './jodit'
import lastUpdates from './lastUpdates'
import leaflet from './leaflet'
import legalFrameworks from './legalFrameworks'
import liaAnswers from './liaAnswers'
import liaQuestions from './liaQuestions'
import logs from './logs'
import marketplace from './marketplace'
import monitoringManagementKpi from './monitoringManagementKpi'
import monitoringManagementNc from './monitoringManagementNc'
import monitoringManagementPmc from './monitoringManagementPmc'
import moodle from './moodle'
import myLgpd from './myLgpd'
import necessityAndProportionalities from './necessityAndProportionalities'
import nonComplianceReports from './nonComplianceReports'
import organizations from './organizations'
import order from './order'
import orderFilter from './orderFilter'
import outsourcedDpo from './outsourcedDpo'
import partner from './partner'
import phishing from './phishing'
import permissions from './permissions'
import permissionsLists from './permissionsLists'
import plan from './plan'
import planAction from './planAction'
import preRegistrations from './preRegistrations'
import privacyByDesign from './privacyByDesign'
import privacyByDesignAnswer from './privacyByDesignAnswer'
import privacyByDesignAuditEntity from './privacyByDesignAuditEntity'
import privacyPortal from './privacyPortal'
import privacyStamps from './privacyStamps'
import privacyUniversity from './privacyUniversity'
import profile from './profile'
import questionControl from './questionControl'
import questionnaire from './questionnaire'
import questionOptionTickets from './questionOptionTickets'
import questions from './questions'
import quizTemplates from './quizTemplates'
import recurrence from './recurrence'
import regulations from './regulations'
import reports from './reports'
import reportVersions from './reportVersions'
import ripdRisk from './ripdRisk'
import settings from './settings'
import sharedSoftware from './sharedSoftware'
import smtp from './smtp'
import suggestionChanges from './dataProcessSuggestionChanges'
import supplierInvite from './supplierInvite'
import supplierJourney from './supplierJourney'
import suppliers from './suppliers'
import supplierSuggestion from './supplierSuggestion'
import technicalFaqs from './technicalFaqs'
import theme from './theme'
import thirdPartyManagements from './thirdPartyManagements'
import ticketMessages from './ticketMessages'
import tickets from './tickets'
import tours from './tours'
import trailsJourney from './trailsJourney'
import unnecessaryData from './unnecessaryData'
import user from './user'
import userCompanies from './userCompanies'
import userSteps from './userSteps'
import userTrailSteps from './userTrailSteps'
import validations from './validations'

const constants = {
  activities,
  aiInventory,
  alert,
  assetInventory,
  auditProcess,
  audits,
  cardFlag,
  certificates,
  changesManagement,
  committees,
  community,
  company,
  externalServices,
  companyGuestPortalConfig,
  companySuppliers,
  companyTrail,
  complaint,
  consent,
  consentFormReports,
  contactQuestionnaire,
  cookies,
  countries,
  course,
  courseAccess,
  dai,
  dataCollected,
  dataIntelligence,
  dataProcess,
  dataProcessTreatment,
  dataTreatmentAgents,
  date,
  departments,
  diffViewer,
  discountCoupon,
  documents,
  documentsValidations,
  dpoday,
  errors,
  evaluationSettings,
  externalPlatformIntegrations,
  faqs,
  faqsDocumentations,
  fragilities,
  fragilityEntities,
  googleTagManager,
  governanceProject,
  governanceProjectActivity,
  governanceProjectSettings,
  guestJourney,
  governanceProjectStages,
  incidentAcceptTexts,
  incidentHighRisk,
  incidentManegement,
  incidentRiskAssumption,
  incidents,
  inviteAdvisor,
  jodit,
  lastUpdates,
  leaflet,
  legalFrameworks,
  liaAnswers,
  liaQuestions,
  logs,
  marketplace,
  monitoringManagementKpi,
  monitoringManagementNc,
  monitoringManagementPmc,
  moodle,
  myLgpd,
  necessityAndProportionalities,
  nonComplianceReports,
  organizations,
  order,
  orderFilter,
  outsourcedDpo,
  partner,
  phishing,
  permissions,
  permissionsLists,
  plan,
  planAction,
  preRegistrations,
  privacyByDesign,
  privacyByDesignAnswer,
  privacyByDesignAuditEntity,
  privacyPortal,
  privacyStamps,
  privacyUniversity,
  profile,
  questionControl,
  questionnaire,
  questionOptionTickets,
  questions,
  quizTemplates,
  recurrence,
  regulations,
  reports,
  reportVersions,
  ripdRisk,
  settings,
  sharedSoftware,
  smtp,
  suggestionChanges,
  supplierInvite,
  supplierJourney,
  suppliers,
  supplierSuggestion,
  technicalFaqs,
  theme,
  thirdPartyManagements,
  ticketMessages,
  tickets,
  tours,
  trailsJourney,
  unnecessaryData,
  user,
  userCompanies,
  userSteps,
  userTrailSteps,
  validations,
}

export default constants
